import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import ProductStatusFilter from './ProductStatusFilter';
import useTable from '../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import Popup from '../Popup';
import UpdateProduct from './UpdateProduct';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import { Helmet } from 'react-helmet';
import { getProductDocumentWithUserId } from '../../Backend/firebase/product';
import { dateFormatter } from '../Models/CommonFunc';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'ProductName', label: 'Product Name', disableSorting: false },
    { id: 'Compostions', label: 'Compostions', disableSorting: true },
    { id: 'PackagingType', label: 'Packaging Type', disableSorting: true },
    { id: 'MRP', label: 'MRP', disableSorting: true },
    { id: 'Discount', label: 'Discount', disableSorting: true },
    { id: 'ExpiryDate', label: 'Expiry Date', disableSorting: false },
    { id: 'BatchNo', label: 'Batch No', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false },
]

function AllProducts() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openPopup, setOpenPopup] = useState(false);
    const [updatedProductId, setUpdatedProductId] = useState('');
    const [uniqueProductId, setUniqueProductId] = useState('');
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.ProductName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProducts = await getProductDocumentWithUserId(userData.uid);
                setRecords(getProducts);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Products", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const updateProductPost = (_id, productId) => {
        setUniqueProductId(_id);
        setUpdatedProductId(productId);
        setOpenPopup(true);
    };

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProducts = await getProductDocumentWithUserId(userData.uid);
                console.log("getProducts",getProducts)
                setRecords(getProducts);
                setIsLoading(false);
                setNotificationMessage('Products data has updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Products", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProducts">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Products you have posted till now." />
                            <title>Products | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="filterUpperBox">
                                <div className="row filterBox">
                                    <div className="col-md-8">
                                        <ProductStatusFilter handleFilters={handleFilters} refreshData={refreshData} />
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                            <SearchIcon className="mr-2" />
                                            <input type="text" placeholder="Search products" className="border-0"
                                                onChange={handleSearch} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                {/* <TblContainer>
                                    <TblHead />
                                    <TableBody> */}
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                        <div className="card-events card-products all-products">
                                                            <div className="card-events-body d-flex flex-column background__white__color position__class">
                                                                <div className="product__edit">
                                                                    <Tooltip title="Edit Product" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => updateProductPost(item._id, item.uniqueId)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="card-events-details">
                                                                    <h5 className="card-events-title text__black__color product__mainTitle">{item.ProductName}</h5>
                                                                    <p className="card-events-title text__black__color">{item.Compostions}</p>
                                                                    <p className="card-events-title text__black__color">MRP: <b>{item.MRP ? `Rs. ${item.MRP}` : '0'}</b></p>
                                                                    {item.Discount && <p className="card-events-title text__black__color">Discount: <b>{item.Discount ? `${item.Discount}%` : '0'}</b></p>}
                                                                    {item.ExpiryDate && <p className="card-events-title text__black__color">Expiry Date: <b>{typeof item.ExpiryDate == "string" ? item.ExpiryDate : dateFormatter(item.ExpiryDate.toDate().toString())}</b></p>}
                                                                    {item.BatchNo && <p className="card-events-title text__black__color">Batch No: <b>{item.BatchNo}</b></p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <TableRow key={item.id}>
                                                        <TableCell>{item.ProductName}</TableCell>
                                                        <TableCell>{item.Compostions}</TableCell>
                                                        <TableCell>{item.PackagingType}</TableCell>
                                                        <TableCell>
                                                            <span style={{
                                                                backgroundColor: '#000000', color: 'white', padding: '5px 2px',
                                                                borderRadius: '2px', fontWeight: '500'
                                                            }}>{item.MRP ? `Rs. ${item.MRP}` : '0'}</span>
                                                        </TableCell>
                                                        <TableCell>
                                                            <span style={{
                                                                backgroundColor: 'red', color: 'white', padding: '5px 2px',
                                                                borderRadius: '2px', fontWeight: '500'
                                                            }}>{item.Discount ? `${item.Discount} %` : '0'}</span>
                                                        </TableCell>
                                                        <TableCell>{item?.ExpiryDate}</TableCell>
                                                        <TableCell>{item.BatchNo}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Product" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => updateProductPost(item._id, item.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow> */}
                                                </>
                                            ))
                                        }
                                    {/* </TableBody>
                                </TblContainer> */}
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-5 text-center">
                                <h4>No Products Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Product" popupSize="lg">
                <UpdateProduct _id={uniqueProductId} productId={updatedProductId} setOpenPopup={setOpenPopup} />
            </Popup>
        </>
    )
}

export default AllProducts
